module.exports = __webpack_public_path__ + "img/ios-heart-dislike.a335ca3d.svg";